import React, { useState, useEffect } from 'react';
import Link from './link';

const ProductContactButton = ({ product, page, metafields }) => {
  const [currentVariant, setCurrentVariant] = useState(null);

  useEffect(() => {
    if (product.variants && product.variants.length > 0) {
      setCurrentVariant(product.variants[0]);
    }
  }, [product.variants]);
  
  return (
    <>
      {currentVariant && !page && (
        <div className="ProductPage__content__code" style={{ marginBottom: '2rem' }}>Product Code: {currentVariant.sku}</div>
      )}

      {
        !page && (
          <>
            {
              metafields?.hiding?.hidingAddToCartText ? (
                <p>{metafields.hiding.hidingAddToCartText}</p>
              ) : (
                <p>Click the 'Request Price Details' button to discover our offers and get in touch.</p>
              )
            }
          </>
        )
      }

      <Link to={`/contact`} className="Button Button__secondary--outline">
        {metafields?.hiding?.hidingAddToCartButtonText ? metafields.hiding.hidingAddToCartButtonText : 'Request Price Details'}
      </Link>
    </>
  );
}

export default ProductContactButton;
